import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const DesignationUrl = `${Base_Url}/Designation`;

export const GetDesignationList = async (params) => {
  const res = await postApiWithAuthorization(
    `${DesignationUrl}/GetDesignationList`,
    params
  );
  return res;
};

export const AddUpdateDesignation = async (params) => {
  const res = await postApiWithAuthorization(
    `${DesignationUrl}/AddUpdateDesignation?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetDesignationModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/GetDesignationModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};

export const ChangeDesignationStatus = async (
  ModuleName,
  KeyID,
  adminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/ChangeDesignationStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};

export const DeleteDesignation = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/DeleteDesignation?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};
